export const PROD = true;

export let BASE_URL =
  PROD === true
    ? `https://primary.notunkurifoundation.com`
    : // ? `https://coaching.notunkurifoundation.com`
      `http://localhost:5001`;

export let PAYMENT_SITE_URL =
  PROD === true
    ? `https://payment.notunkurifoundation.com`
    : `http://localhost:5002`;
